// extracted by mini-css-extract-plugin
module.exports = {"Header":"CourseWorkPageInfo_Header__15nZp"};